import { useEffect } from "react";
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import { IdleTimerProvider } from "react-idle-timer";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import Dashboard from "./modules/dashboard/Dashboard";
import ImportPDF from "./modules/importPDF/ImportPDF";
import Admin from "./modules/admin/Admin";
import { QueryObjects } from "./modules/query-objects/QueryObjects";
import Login from "./modules/login/Login";
import LeadgenNoData from "./modules/leadgen/components/leadgen-no-data/LeadgenNoData";
import Leadgen from "./modules/leadgen/Leadgen";
import AddNewEntity from "./modules/add-new-entity/AddNewEntity";
import Leads from "./modules/leads/Leads";
import LPSForm from "./modules/lps-form/LPSForm";
import NotFoundPage from "./containers/not-found-page/404";
import Layout from "./containers/main-layout/Layout";
import SuperAdmin from "./modules/super-admin/SuperAdmin";
import LoginLayout from "./containers/login-layout/LoginLayout";
import UserService from "./common/services/user.service";

import { authCheckRequest } from './modules/login/actions';
import "./App.styles";
import Modals from "./common/components/modal/containers/Modals";
import theme from "./App.styles";
import { CssBaseline } from "@mui/material";
import  PrivateRoute from "./common/components/routers/PrivateRoute";
import { selectUser } from './modules/login/selectors';

const App = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const token = UserService.token;
  const { checked, isAuthed } = useSelector(selectUser);
  // useEffect(() => {
  //
  //   // if (!UserService.token && window.location.pathname !== "/login") {
  //   //   navigate("/login");
  //   // }
  //
  //   if (
  //     token &&
  //     (window.location.pathname === "/login" ||
  //       window.location.pathname === "/")
  //   ) {
  //     navigate("/dashboard", { replace: true });
  //   }
  //   if (token) {
  //   // if (localStorage.getItem("token")) {
  //     dispatch(getCurrentUserRequest(navigate));
  //   }
  //
  // }, [dispatch, navigate, token]);
  useEffect(() => {
    dispatch(authCheckRequest());
  }, [dispatch]);

  if (!checked) return null;
  const minutes = 1000 * 60 * 60; // 60 minutes to logout;
  // const minutes = 40000; // 40 seconds to logout;
  const onIdle = () => {
    console.log("Logout Time ", Date());
    UserService.logout();
    navigate("/login", { state: <Login /> });
  };

  return (
    <>
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <ToastContainer autoClose={3000} style={{zIndex: 999999}} />
        <IdleTimerProvider timeout={minutes} onIdle={onIdle}>
          <Routes>
            <Route
              path="/"
              element={
                isAuthed ? (
                  <Navigate to="/dashboard" replace />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />
            <Route path="/login" element={<LoginLayout />} />
            <Route element={<Layout />}>
              <Route path="/dashboard" element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              } />
              <Route path="/import-pdf" element={
                <PrivateRoute>
                  <ImportPDF />
                </PrivateRoute>
              } />
              <Route path="/admin" element={
                <PrivateRoute>
                  <Admin />
                </PrivateRoute>
              } />
              <Route path="/query-objects" element={
                <PrivateRoute>
                  <QueryObjects />
                </PrivateRoute>
              } />
              <Route path="/leadgen" element={
                <PrivateRoute>
                  <LeadgenNoData />
                </PrivateRoute>
              } />
              <Route path="/leadgen/:model/:id" element={
                <PrivateRoute>
                  <Leadgen />
                </PrivateRoute>
              } />
              <Route path="/add-new" element={
                <PrivateRoute>
                  <AddNewEntity />
                </PrivateRoute>
              } />
              <Route path="/leads" element={
                <PrivateRoute>
                  <Leads />
                </PrivateRoute>
              } />
              <Route path="/lps-form" element={
                <PrivateRoute>
                  <LPSForm />
                </PrivateRoute>
              } />
              <Route path="/super-admin" element={
                <PrivateRoute>
                  <SuperAdmin />
                </PrivateRoute>
              } />
              <Route path="*" element={
                <PrivateRoute>
                  <NotFoundPage />
                </PrivateRoute>
              } />
            </Route>
          </Routes>
          { isAuthed && window.location.pathname !== "/login" ? <Modals /> : null}
        </IdleTimerProvider>
      </ThemeProvider>

    </>
  );
};

export default App;
